/*
Replace
supplier with your resource Name :) Take care about different writings!
/!\ Supplier supplier Suppliers suppliers /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const supplierSlice = createSlice({
  name: "suppliers",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listSuppliers,
  show: showSupplier,
  create: createSupplier,
  update: updateSupplier,
} = supplierSlice.actions;

export const actions = supplierSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const suppliers = (state) =>
  state.suppliers.idsList.map((id) => state.suppliers.dictionary[id]);
export const supplier = (state) =>
  state.suppliers.showId && state.suppliers.dictionary[state.suppliers.showId];
export const supplierAttributes = (state) => supplier(state)?.attributes;
export const supplierRelationships = (state) => supplier(state)?.relationships;
export const supplierId = (state) => state.suppliers.showId;

export const getSupplier = createSelector(
  (state) => state.suppliers.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getSupplierAttributes = createSelector(
  (state) => state.suppliers.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getSupplierRelationships = createSelector(
  (state) => state.suppliers.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getSuppliers = createSelector(
  (state) => state.suppliers.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default supplierSlice.reducer;
